import { combineReducers } from 'redux';

import { Template } from 'entities/template';
import { GenericAction, genericReducer, GenericState } from 'services/genericAPIGatewayService';
import { Service } from './services';
import { Sagas as TemplatesSagas } from './templates';

export type Action = GenericAction<Template, Service.Templates>;

export interface State {
  templates: GenericState<Template>;
}

export const reducer = combineReducers<State>({
  templates: genericReducer<Template, Service.Templates>(Service.Templates),
});

export const Sagas = [...TemplatesSagas];
